// extracted by mini-css-extract-plugin
module.exports = {"detailsContent":"details_detailsContent__2LaKo","container":"details_container__Jdaii","jionBtnWrap":"details_jionBtnWrap__JdT5A"};